const initialState ={
  settings:undefined,
  data:{},
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
      case 'REQUEST_INDEX_CHART_DATA_SUCCESS':
      case 'REQUEST_INDEX_TIMELINE_ITEMS_SUCCESS':
        newState.data[action.key]=action.val;
        newState.refresh+=1;
      break;
      case 'REQUEST_GET_ANALYTICS_SETTINGS_SUCCESS':
      case 'REQUEST_CREATE_UPDATE_ANALYTICS_CHART_SUCCESS':
      case 'REQUEST_DELETE_ANALYTICS_CHART_SUCCESS':
         newState.settings=action.val;
         newState.refresh+=1;
      break;
      case 'REQUEST_INDEX_SCORECARDS_SUCCESS':
         if(newState.scorecards==undefined){newState.scorecards={}}
         for(let s of action.val){
           newState.scorecards[s.id]=s;
         }
         newState.refresh+=1;
      break;
      case 'REQUEST_CREATE_SCORECARD_SUCCESS':
      case 'REQUEST_UPDATE_SCORECARD_SUCCESS':
         if(newState.scorecards==undefined){newState.scorecards={}}
         newState.scorecards[action.val.id]=action.val;
         newState.refresh+=1;
      break;
      case 'UPDATE_SCORECARD_TIMELINE_ITEM':
      case 'UPDATE_SCORECARD_TASK_COMPLETED':
      case 'UPDATE_SCORECARD_NEW_PROSPECT':
      case 'UPDATE_SCORECARD_CREATE_DEAL':
      case 'UPDATE_SCORECARD_UPDATE_DEAL':
        if(action.type!='UPDATE_SCORECARD_TASK_COMPLETED' || action.val.task_queue_timeline_item[0].completed_on!=undefined){
           if(newState.scorecards!=undefined && (action.type=='UPDATE_SCORECARD_CREATE_DEAL' || action.type=='UPDATE_SCORECARD_UPDATE_DEAL' || action.type=='UPDATE_SCORECARD_NEW_PROSPECT' || isToday((action.type=='UPDATE_SCORECARD_TASK_COMPLETED')?action.val.task_queue_timeline_item[0].completed_on:action.val.date_time)==true)){
             for(let sk in newState.scorecards){
               let s=newState.scorecards[sk];
               for(let st of s.scorecard_trackers){
                 if(st.type=='PHONE_CALLS_OUTGOING' && action.type=='UPDATE_SCORECARD_TIMELINE_ITEM'){if(action.val.type==1 && action.val.sub_type==1){st.quantity+=1;}}
                 else if(st.type=='PHONE_CALL_ATTEMPTS' && action.type=='UPDATE_SCORECARD_TIMELINE_ITEM'){if(action.val.type==1 && action.val.sub_type!=0){st.quantity+=1;}}
                 else if(st.type=='MEETINGS_BOOKED' && action.type=='UPDATE_SCORECARD_TIMELINE_ITEM'){if(action.val.type==3){st.quantity+=1;}}
                 else if(st.type=='EMAILS_SENT' && action.type=='UPDATE_SCORECARD_TIMELINE_ITEM'){if(action.val.type==0 && (action.val.sub_type==0 || action.val.sub_type==2)){st.quantity+=1;}}
                 else if(st.type=='TASKS_COMPLETED' && action.type=='UPDATE_SCORECARD_TASK_COMPLETED'){st.quantity+=1;}
                 else if(st.type=='NEW_PROSPECTS' && action.type=='UPDATE_SCORECARD_NEW_PROSPECT'){st.quantity+=1;}
                 else if(action.type=='UPDATE_SCORECARD_CREATE_DEAL'){if(st.type=='DEALS_OPENED' && (action.val.outcome==7 || action.val.outcome==8 || action.val.outcome==9)){st.quantity+=1;}else if(st.type=='OPPORTUNITIES_OPENED'){st.quantity+=1;}}
                 else if(st.type=='DEALS_OPENED' && action.type=='UPDATE_SCORECARD_UPDATE_DEAL'){if((action.val.outcome==7 || action.val.outcome==8 || action.val.outcome==9) && (action.val.old_outcome!=7 && action.val.old_outcome!=8 && action.val.old_outcome!=9)){st.quantity+=1;}else if((action.val.old_outcome==7 || action.val.old_outcome==8 || action.val.old_outcome==9) && (action.val.outcome!=7 && action.val.outcome!=8 && action.val.outcome!=9)){st.quantity-=1;}}
               }
             }
           }}
         newState.refresh+=1;
      case 'REQUEST_DELETE_SCORECARD_SUCCESS':
         if(newState.scorecards!=undefined && newState.scorecards[action.val.id]!=undefined){
           delete newState.scorecards[action.val.id];
           newState.refresh+=1;
         }
      break;
    }
  return newState;
}

function isToday(co){let otherDate=new Date(getDateTimeHere(co)); let todayDate=new Date(); if ( otherDate.getDate() === todayDate.getDate() && otherDate.getMonth() === todayDate.getMonth() && otherDate.getYear() === todayDate.getYear() ) {return true;} else {return false;}}


export default reducer;
